import axios from "axios";
import apiURI from "./Api";

export default class PhysicalStoreService {
  async createTransaction({ amount, user, description }) {
    const bodyJson = {
      amount: amount,
      seller_username: user,
      description: description || undefined,
    };

    const response = await axios({
      method: "post",
      url: `${apiURI}/store/createTransaction`,
      data: bodyJson,
      headers: { Authorization: "Bearer " + localStorage.getItem("__extraconomy_token") },
    });

    return response.data;
  }

  async getAllPayments() {
    const response = await axios({
      method: "get",
      url: `${apiURI}/store/getAllPayments/${localStorage.getItem("__extraconomy_username")}`,
      headers: { Authorization: "Bearer " + localStorage.getItem("__extraconomy_token") },
    });

    return response.data;
  }

  async getPayment(id) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/store/getPaymentById/${id}`,
      headers: { Authorization: "Bearer " + localStorage.getItem("__extraconomy_token") },
    });

    return response.data;
  }

  async verificationStatus(username) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/store/physicalStore/verificationStatus/${username}`,
      headers: { Authorization: "Bearer " + localStorage.getItem("__extraconomy_token") },
    });
    return response.data;
  }

  async submitProof({
    physicalStoreName,
    physicalAddress,
    physicalNumber,
    physicalDistrict,
    physicalCity,
    physicalState,
    physicalPostalCode,
    physicalCountry,
    proofPhotoId,
    username,
    proofPhotoUrl,
  }) {
    const response = await axios({
      method: "post",
      url: `${apiURI}/store/physicalStore/submitProof`,
      data: {
        physicalStoreName,
        physicalAddress,
        physicalNumber,
        physicalDistrict,
        physicalCity,
        physicalState,
        physicalPostalCode,
        physicalCountry,
        proofPhotoUrl,
        proofPhotoId,
        username,
      },
      headers: { Authorization: "Bearer " + localStorage.getItem("__extraconomy_token") },
    });
    return response.data;
  }

  async getApprovedStores() {
    const response = await axios({
      method: "get",
      url: `${apiURI}/store/physicalStore/approvedStores`,
      headers: { Authorization: "Bearer " + localStorage.getItem("__extraconomy_token") },
    });
    return response.data;
  }

  async approveStore(username) {
    const response = await axios({
      method: "post",
      url: `${apiURI}/admin/physicalStore/approve/${username}`,
      headers: { Authorization: "Bearer " + localStorage.getItem("__extraconomy_token") },
    });
    return response.data;
  }

  async rejectStore(username, reason) {
    const response = await axios({
      method: "post",
      url: `${apiURI}/admin/physicalStore/reject/${username}`,
      params: { reason },
      headers: { Authorization: "Bearer " + localStorage.getItem("__extraconomy_token") },
    });
    return response.data;
  }

  async getPendingVerifications() {
    const response = await axios({
      method: "get",
      url: `${apiURI}/admin/physicalStore/pendingVerifications`,
      headers: { Authorization: "Bearer " + localStorage.getItem("__extraconomy_token") },
    });
    return response.data;
  }

  async getConventionPreview(username) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/store/physicalStore/convention/preview/${username}`,
      headers: { Authorization: "Bearer " + localStorage.getItem("__extraconomy_token") },
    });
    return response.data;
  }

  async signConvention(data) {
    const response = await axios({
      method: "post",
      url: `${apiURI}/store/physicalStore/convention/sign`,
      data,
      headers: { Authorization: "Bearer " + localStorage.getItem("__extraconomy_token") },
    });
    return response.data;
  }

  async confirmTransaction({
    amount,
    authentication,
    paymentid,
    amountWalletExtraCredit,
    buyer_username,
  }) {
    const bodyJson = {
      amountWallet: amount,
      amountWalletExtraCredit: amountWalletExtraCredit,
      authentication: authentication,
      buyer_username: buyer_username,
      paymentid: paymentid,
    };

    const response = await axios({
      method: "post",
      url: `${apiURI}/store/confirmTransaction`,
      data: bodyJson,
      headers: { Authorization: "Bearer " + localStorage.getItem("__extraconomy_token") },
    });

    return response.data;
  }
}
